module.exports = __webpack_public_path__ + "media/11_15.caa896e7.wav";